<template>
  <div class="col-xs-12 col-sm-12 container">
    <div class="alert alert-danger" v-if="errorMsg">
      <p>{{ errorMsg }}</p>
    </div>
    <div class="alert alert-info" v-if="alertMsg">
      <p>{{ alertMsg }}</p>
    </div>
    <h3>
      <strong>{{ email }}</strong>
    </h3>

    <div class="form-group" v-show="pending">
      <input
        class="form-control"
        type="password"
        placeholder="Enter your old password"
        v-model="userData.OldPassword"
      />
    </div>
    <div class="form-group" v-show="pending">
      <input
        class="form-control"
        type="password"
        placeholder="Enter your new password"
        v-model="userData.NewPassword"
      />
    </div>

    <div class="pull-right">
      <button
        class="btn btn-title btn-success"
        v-show="pending"
        @click="changePassword()"
      >
        Save
      </button>
      <button
        class="btn btn-title btn-default"
        v-show="pending"
        @click="closeModal()"
      >
        Cancel
      </button>
    </div>
  </div>
</template>

<script>
import auth from "../../auth/index";
import store from "../../data/store";

export default {
  name: "ChangePassword",
  data() {
    return {
      userData: {
        OldPassword: "",
        NewPassword: "",
        ConfirmPassword: "",
      },
      code: "",
      error: "",
      alert: "",
      pending: true,
    };
  },
  methods: {
    closeModal() {
      $("#changePassword").modal("hide");
    },
    changePassword() {
      self = this;
      self.userData.ConfirmPassword = self.userData.NewPassword;
      $.ajax({
        type: "POST",
        url: "https://www.dupaws.com/services/api/account/ChangePassword",
        beforeSend: function (xhr) {
          xhr.setRequestHeader(
            "Authorization",
            "bearer " + localStorage.getItem("access_token")
          );
        },
        data: JSON.stringify(self.userData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function (data) {
          self.alert = "Password successfully changed..";
          self.pending = false;
          self.error = "";
        },
        error: function () {
          try {
            self.error = "Password save failed, is old password correct?";
          } catch (e) {
            context.error =
              "Oops we are having problem logging to the server, please try again in a moment..";
          }
        },
      });
    },
  },
  mounted: function () {},
  computed: {
    errorMsg: function () {
      return this.error;
    },
    alertMsg: function () {
      return this.alert;
    },
    email: function () {
      return localStorage.getItem("email");
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// ChangePassword.vue?1ce2d2ca